import React, { FormEvent } from 'react';
import { Button, MenuItem, styled, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import FilterBox from 'components/filter-box/FilterBox';
import KeyboardDatePicker from 'components/pickers/KeyboardDatePicker';
import { ReportSurgerieQueryParams } from './hooks/useFetchReportSurgeries';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '160px 180px 180px 150px repeat(3, minmax(180px, 1fr)) 100px',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type ReportSurgerieFilterBoxProps = {
  filter: ReportSurgerieQueryParams;
  handleChange(index: keyof ReportSurgerieQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const ReportSurgerieFilterBox: React.FC<ReportSurgerieFilterBoxProps> = ({
  filter,
  loading,
  handleChange,
  handleSearch,
}) => {
  const dateLabel = filter.date_filter === 'closed_at' ? 'Fechamento' : 'Emissão';

  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          select
          label="Pesquisar por"
          value={filter.date_filter}
          onChange={e => handleChange('date_filter', e.target.value)}
        >
          <MenuItem value="created_at">Emissão</MenuItem>
          <MenuItem value="closed_at">Fechamento</MenuItem>
        </TextField>
        <KeyboardDatePicker
          label={`${dateLabel} inicial`}
          value={filter.initial_date}
          onChange={date => handleChange('initial_date', date)}
        />
        <KeyboardDatePicker
          label={`${dateLabel} final`}
          value={filter.final_date}
          onChange={date => handleChange('final_date', date)}
        />
        <TextField select label="Status" value={filter.status} onChange={e => handleChange('status', e.target.value)}>
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="open">Abertos</MenuItem>
          <MenuItem value="closed">Fechados</MenuItem>
        </TextField>
        <TextField
          label="Paciente"
          value={filter.patient_name}
          onChange={e => handleChange('patient_name', e.target.value)}
        />
        <TextField
          label="Médico"
          value={filter.doctor_name}
          onChange={e => handleChange('doctor_name', e.target.value)}
        />
        <TextField
          label="Hospital"
          value={filter.hospital_name}
          onChange={e => handleChange('hospital_name', e.target.value)}
        />

        <Button
          className="search-button"
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default ReportSurgerieFilterBox;
